import messages_bg from "../textProperties/bg.json"
import {ToastContextProvider} from "./context/ToastContext";
import {DialogContextProvider} from "./context/DialogContext";
import {usePreloader} from "./hooks/usePreloader";
import React, {useState} from "react";
import {Key, SWRConfig, SWRHook} from "swr";
import {BrowserRouter} from "react-router-dom";
import App from "../App";
import {IntlProvider} from "react-intl";
import {AxiosInterceptor} from "./AxiosInterceptor";
import axios from "axios";


interface Props {
}


export const AppProxy: React.FC<Props> = (props) => {
    const messages = {'bg': messages_bg}
    const [interceptorReady, setInterceptorReady] = useState(false);
    const {setLoading} = usePreloader();

    const handleInterceptorReady = () => {
        setInterceptorReady(true);
    }


    const proxyMiddleware = (next: SWRHook) => {
        return (key: Key, fetcher: any, config: any) => {
            const extendedFetcher = (...args: any) => {
                args.push(true);
                return fetcher(args);
            }

            return next(key, extendedFetcher, config);
        }
    }


    return <>
        <IntlProvider locale={"bg-BG"} messages={messages.bg}>
            <ToastContextProvider>
                <DialogContextProvider>
                    <AxiosInterceptor callback={handleInterceptorReady}>
                        <SWRConfig value={{
                            fetcher: ([url, isSWR]) => axios(url, {data: {isSWR}}).then(response => response.data),
                            use: [proxyMiddleware]
                        }}>
                            <BrowserRouter>
                                {interceptorReady ? <App/> : null}
                            </BrowserRouter>
                        </SWRConfig>
                    </AxiosInterceptor>
                </DialogContextProvider>
            </ToastContextProvider>
        </IntlProvider>


    </>

}